import { Button, Divider, IconButton } from '@material-ui/core';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlineBlank';
import Checkbox from '@material-ui/icons/CheckBoxOutlined';
import EditIcon from '@material-ui/icons/Edit';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import DeviationIcon from '@material-ui/icons/CallSplitRounded';
import React from 'react';
import styled from 'styled-components';
import Utils from '../../Utils';
import ProceduresContext from './ProceduresContext';
import GridTemplateColumns from './GridTemplateColumns'
import Tooltip from '../common/CustomTooltip';
import { connect } from 'react-redux';


const SubHeader = styled.div`
padding-top:10px;
display:grid;
grid-template-columns: ${GridTemplateColumns};
padding-left:10px;
padding-right:10px;
padding-bottom:10px;
align-items:center;
`;

const SubHeaderText = styled.div`
color: black;
font-family: Roboto;
font-size: 14px;
font-weight: 400;
line-height: 19px;
text-align: left;
margin-right:20px;
`;

const AddToWorkflowContainer = styled.div`
width:100px;
`;

const EditExistingIconContainer = styled.div`
padding-left:10px;
padding-right:10px;
`;

const EditIconContainer = styled.div`
    padding-left:10px;
    padding-right:10px;
`;

const Container = styled.div`
&:hover {
    background:#E8E8E8;
}
&:not(:hover) ${EditExistingIconContainer} {
    display: none;
  }
`;

const ButtonText = styled.div`
color: black;
font-family: Roboto;
font-size: 12px;
font-weight: 500;
line-height: 16px;
text-align: center;
`;

const EndItems = styled.div`
padding-top:10px;
display:flex;
padding-left:10px;
padding-right:10px;
padding-bottom:10px;
align-items:center;
`;

const IconButtonContainer = styled.div`
  display:flex;
  justify-content:flex-start;
`;

const ButtonContainer = styled.div`
`;
class ProceduresListItem extends React.Component {
    static contextType = ProceduresContext;

    render() {
        const { procedure = {}, selectedFunction, proceduresFromRedux, isProjectSetupPage } = this.props;
        const { name, rev, effectiveDate, url, sdn, id, isNew, categoryName, gbuId, isDeviating } = procedure;
        const currentGBUAdminGBUs = this.context.aboutCurrentUser.permissions.filter(x => x.hasRole === true && x.scope === 'GBU' && x.assetId).map(t => t.assetId);
        const currentOmFunctions = this.context.aboutCurrentUser.permissions.filter(x => x.hasRole === true && x.scope === 'FUNC' && x.assetId).map(t => t.assetId);
        const canCurrentUserEditProcedures = (this.context.aboutCurrentUser.isGbuAdmin && currentGBUAdminGBUs.some(x => x === gbuId)) || (this.context.aboutCurrentUser.isOM && currentOmFunctions.some(x => x === selectedFunction.id)) || this.context.canCurrentUserEditProcedures;
        let allowDeviation = false;

        if (isProjectSetupPage && proceduresFromRedux && proceduresFromRedux.length) {
            const procedureFromRedux = proceduresFromRedux.filter((procedureFromRedux) => {
                return procedure.id == procedureFromRedux.id
            })

            allowDeviation = procedureFromRedux.length && (procedureFromRedux[0].currentState.toLowerCase() == "In Progress".toLowerCase() || procedureFromRedux[0].currentState.toLowerCase() == "COMPLETE".toLowerCase())
            allowDeviation = allowDeviation && isDeviating
        } else {
            allowDeviation = isDeviating
        }

        return (
            <Container>
                <SubHeader>
                    <div />
                    <SubHeaderText>{sdn}</SubHeaderText>
                    <SubHeaderText>{name}</SubHeaderText>
                    <SubHeaderText >{categoryName}</SubHeaderText>
                    <SubHeaderText>{rev}</SubHeaderText>
                    <SubHeaderText>{Utils.formatDate(effectiveDate)}</SubHeaderText>
                    <IconButtonContainer>
                        <Tooltip title={url}>
                            <IconButton disabled={!url} color='primary' onClick={() => window.open(url, '_blank')}>
                                <OpenInNewIcon />
                            </IconButton>
                        </Tooltip>
                    </IconButtonContainer>

                    <IconButtonContainer>
                        <IconButton disabled={!allowDeviation} color='primary' onClick={() => window.open(`/api/functions/getFunctionsProcedureDeviationFile/${selectedFunction.id}/${sdn}/${isProjectSetupPage}`, '_self')}>
                            <DeviationIcon />
                        </IconButton>
                    </IconButtonContainer>

                    {
                        !this.context.procedures.procedureBeingEdited && isNew && canCurrentUserEditProcedures &&
                        <EditIconContainer>
                            <IconButton color='primary' onClick={() => this.context.editProcedure(procedure)}>
                                <EditIcon />
                            </IconButton>
                        </EditIconContainer>
                    }
                    {
                        !this.context.procedures.procedureBeingEdited && !isNew && canCurrentUserEditProcedures &&
                        <EditExistingIconContainer>
                            <IconButton color='primary' onClick={() => this.context.editProcedure(procedure)}>
                                <EditIcon />
                            </IconButton>
                        </EditExistingIconContainer>
                    }
                    {
                        !this.context.procedures.procedureBeingEdited && procedure.id && isNew && canCurrentUserEditProcedures &&
                        <AddToWorkflowContainer>

                            <Button fullWidth variant="contained" onClick={() => this.context.addProcedureToFunctionWorkflow(id, selectedFunction.id)}>
                                <ButtonText>Publish</ButtonText>
                            </Button>
                        </AddToWorkflowContainer>
                    }
                </SubHeader >
                <Divider />
            </Container >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        proceduresFromRedux: state.procedureManual.procedures
    };
};

export default connect(mapStateToProps, {})(ProceduresListItem);